import { frontPaths } from '@/config/frontPaths.ts'

export const goToHomePage = () => (window.location.href = frontPaths.home)

export const goToLoginPage = () =>
  (window.location.href = frontPaths.security.login)
